var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallToActionBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1677,
    height: 262.18,
    viewBox: "0 0 1677 262.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700",
    transform: "translate(1 4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 6,
    cy: 6,
    rx: 6,
    ry: 6,
    transform: "translate(104 246.179)",
    fill: "#00c3ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 6,
    cy: 6,
    rx: 6,
    ry: 6,
    transform: "translate(1664 41.256)",
    fill: "#00c3ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    transform: "translate(1622 63.104)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeDasharray: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 27,
    cy: 27,
    rx: 27,
    ry: 27,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27,
    cy: 27,
    rx: 26.5,
    ry: 26.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 13,
    cy: 13,
    rx: 13,
    ry: 13,
    transform: "translate(-1 145.132)",
    fill: "#fee135"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 13,
    cy: 13,
    rx: 13,
    ry: 13,
    transform: "translate(1545 202.179)",
    fill: "#07f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M10,0,20,18H0Z",
    transform: "translate(359.451 9.164) rotate(137)",
    fill: "#fe9535"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallToActionBackground);
export default __webpack_public_path__ + "static/media/callToActionBackground.4187e6040bd642d436c973048acc16e8.svg";
export { ForwardRef as ReactComponent };